document.addEventListener("click", function(e)
{
  var target = e.target;

  if(target == null || !target.classList.contains("js-parameter-toggle"))
    return;

  target.classList.toggle("js-active");

  const targetElement = document.querySelector(target.dataset.open);

  targetElement.classList.toggle('k-d-none');
});
